// extracted by mini-css-extract-plugin
module.exports = {"block":"PersonTypes_block__QJWny","fullwidth":"PersonTypes_fullwidth__2f1KV","name":"PersonTypes_name__3Bn2L","description":"PersonTypes_description__1ne9N"};